import { Link } from 'react-router-dom';
import type { FC } from 'react';

const footerLinks = [
  {
    title: '快速导航',
    links: [
      { label: '平台介绍', href: '/category/platform-intro' },
      { label: '使用指南', href: '/category/user-guide' },
      { label: '功能解析', href: '/category/features' },
      { label: '资源中心', href: '/category/resources' },
    ],
  },
  {
    title: '帮助支持',
    links: [
      { label: '常见问题', href: '/category/faq' },
      { label: '注册登录', href: '/article/getting-started-guide' },
      { label: '安全隐私', href: '/article/security-privacy-guide' },
      { label: '联系我们', href: '/about' },
    ],
  },
  {
    title: '关于平台',
    links: [
      { label: '关于我们', href: '/about' },
      { label: '品牌介绍', href: '/about' },
      { label: '发展历程', href: '/about' },
      { label: '用户协议', href: '/about' },
    ],
  },
];

const Footer: FC = () => {
  return (
    <footer className="bg-secondary-50 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="text-xl font-bold text-foreground-950 font-heading whitespace-nowrap">
              17c.com
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              连接智慧，赋能未来。一站式数字化服务平台，为全球用户提供高效、安全、便捷的在线服务体验。
            </p>
            <div className="flex gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-background-100 text-foreground-600 hover:text-primary-600 hover:bg-primary-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-background-100 text-foreground-600 hover:text-primary-600 hover:bg-primary-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-background-100 text-foreground-600 hover:text-primary-600 hover:bg-primary-50 transition-colors cursor-pointer" aria-label="邮箱">
                <i className="ri-mail-line text-lg" />
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4 font-label">
                {group.title}
              </h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 17c.com 版权所有 | 京ICP备xxxxxxxx号-x
          </p>
          <div className="flex gap-4 flex-wrap justify-center">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer whitespace-nowrap">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer whitespace-nowrap">Cookie 政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;